SA.restrictSizeByRatio = function(size, aspectRatio, round) {
    var height = size.height,
        width = size.width,
        min = Math.min,
        roundFn = round ? Math.round : Ext.identityFn;

    return {
        width: min(width, roundFn(height / aspectRatio)),
        height: min(height, roundFn(width * aspectRatio))
    };
};

SA.Math = {
    roundToTwoDecimals(value) {
        return Math.round(value * 100) / 100;
    },

    standardDeviation(values) {
        var count = values.length,
            average = Ext.Array.sum(values) / count,
            squaredDifferences = values.map(value => value - average).map(difference => difference ** 2),
            averageSquaredDifference = Ext.Array.sum(squaredDifferences) / count;

        return Math.sqrt(averageSquaredDifference);
    }
};